import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`A `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#delivery"
        }}>{`Delivery`}</a>{` can only be added to an `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#order"
        }}>{`Order`}</a>{` if its `}<inlineCode parentName="p">{`shippingInfo`}</inlineCode>{` exists.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"addDelivery"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`items`}</inlineCode>{` - Array of `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#deliveryitem"
          }}>{`DeliveryItem`}</a>{` - Optional`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`address`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#addressdraft"
          }}>{`AddressDraft`}</a>{` - Optional`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`parcels`}</inlineCode>{` - Array of `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#parceldraft"
          }}>{`ParcelDraft`}</a>{` - Optional`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`custom`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/custom-fields#customfieldsdraft"
          }}>{`CustomFieldsDraft`}</a>{` - Optional`}</li>
      </ul>
      <p parentName="section">{`This update action produces a `}<a parentName="p" {...{
          "href": "/api/../api/message-types#deliveryaddedmessage"
        }}>{`DeliveryAddedMessage`}</a>{` and the `}<a parentName="p" {...{
          "href": "/api/../api/message-types#parceladdedtodeliverymessage"
        }}>{`ParcelAddedToDeliveryMessage`}</a>{` if the action contains a `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#parcel"
        }}>{`Parcel`}</a>{`.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      